<template>
  <section class="section-base form-section-base">
    <v-container>
      <div class="form-base">
        <v-row>
          <v-col cols="12">
            <div class="form-base__title">
              {{ Text.refusalDetailsTitle }}
            </div>
          </v-col>
        </v-row>

        <BankDetails :v="$v.accountBankDetails" />

        <v-row>
          <v-col cols="12">
            <v-checkbox
              v-model="documentConversionDetails.hasPrivilege"
              label="Наличие льготы"
              hide-details
            />
          </v-col>
          <v-col v-if="documentConversionDetails.hasPrivilege" cols="12">
            <v-textarea
              v-model="$v.documentConversionDetails.note.$model"
              :errorMessages="
                getValidationErrorText($v.documentConversionDetails.note)
              "
              outlined
              label="Примечание (основание для льготы, при наличии)"
            />
            <span class="text-small-size">
              {{ Text.hasPrivilegeNote }}
            </span>
          </v-col>
        </v-row>
      </div>

      <Footer
        @next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
        @prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
        :loading-next="loadingNext"
      />
    </v-container>
  </section>
</template>

<script>
import { maxLength, requiredIf } from 'vuelidate/lib/validators';

import { getValidationErrorText, EMOJI } from '@/utils/validate';
import { checkInvalid, Text, leaveStep } from '@/utils/services';
import { ServicesModule } from '@/store/modules/services';
import Footer from '@/components/services/elements/Footer';
import { StepDirection, StepName } from '@/types/services';
import BankDetails, {
  bankDetails,
  bankDetailsValidation,
} from '@/components/services/elements/BankDetails';
import { DocumentConversionStep } from '@/constants';

export default {
  name: 'AccountBankDetails',
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Footer,
    BankDetails,
  },
  data: () => ({
    StepDirection,
    StepName,
    leaveStep,
    Text,
    getValidationErrorText,
    invalidFields: [],
    accountBankDetails: { ...bankDetails },
    documentConversionDetails: {
      hasPrivilege: false,
      note: '',
    },
  }),
  validations() {
    return {
      accountBankDetails: bankDetailsValidation,
      documentConversionDetails: {
        note: {
          required: requiredIf(
            () => this.documentConversionDetails.hasPrivilege
          ),
          maxLength: maxLength(4000),
          EMOJI,
        },
      },
    };
  },
  created() {
    this.prefillDraft();
  },
  methods: {
    prefillDraft() {
      const SABD = ServicesModule.statement.accountBankDetails;
      const DCD = ServicesModule.statement.documentConversionDetails;

      if (SABD) {
        this.accountBankDetails = { ...this.accountBankDetails, ...SABD };
      }

      if (DCD) {
        this.documentConversionDetails = {
          ...this.documentConversionDetails,
          ...DCD,
        };
      }
    },

    assemblyModel() {
      if (!this.documentConversionDetails.hasPrivilege) {
        this.documentConversionDetails.note = null;
      }

      return {
        accountBankDetails: {
          ...this.accountBankDetails,
        },
        documentConversionDetails: {
          ...this.documentConversionDetails,
        },
      };
    },

    touchFields() {
      this.invalidFields = [];

      this.$v.$touch();
      checkInvalid(this.$v, this.invalidFields);
    },

    btnSaveClickHandler(direction) {
      leaveStep({
        stepThis: this,
        direction,
        step: DocumentConversionStep.BANK_DETAILS,
      });
    },
  },
};
</script>
